export default "__VITE_ASSET__B5RX6uVD__"